export default {
  "init":"測試",
  "ogTitle":"15周年慶典：飛越奇妙夢想城堡\n探索奇妙夢想城堡，立即展開虛擬體驗。",
  "ogSite_name":"15周年慶典：飛越奇妙夢想城堡",
  "ogDescription":"率先體驗奇妙旅程及了解華麗城堡變身後的築夢故事。",
  "siteDescription":"率先體驗奇妙旅程及了解華麗城堡變身後的築夢故事。",
  "quote":"率先體驗奇妙旅程及了解華麗城堡變身後的築夢故事。",
  // "homeURL":"https://hkdl-h5-uat.digitalcampaignasia.com/phase3/zh-hk/campaigns/castleofmagicaldreams/index.html#/",
  "homeURL":"https://www.hongkongdisneyland.com/zh-hk/campaigns/castleofmagicaldreams/index.html",
  "ticketingURL":"https://www.hongkongdisneyland.com/zh-hk/offers-discounts/celebrate-together-group-ticket-offer/?CMP=TixOfrCpn15An21Hkh5CeleToGpTixOfr",
  "exhibitionURL":"https://www.hongkongdisneyland.com/zh-hk/building-a-dream/?CMP=Cpn15An20Hkh5buildadm",
}



// WEBPACK FOOTER //
// ./src/language/tc.js